/* eslint-disable react/prop-types */
import { useState } from "react";
import Input from "react-phone-number-input/input";

import "react-phone-number-input/style.css";
export default function PhoneField(props) {
  const { label, name, formik, placeholder, disabled = false, code } = props;

  return (
    <>
      <label className="block mb-2 text-sm font-medium text-[#494949]">
        {label}
      </label>

      <Input
        name={name}
        country={code}
        international
        withCountryCallingCode
        value={formik.values[name]}
        onChange={(e)=>formik.setFieldValue('phone',e)}
        onBlur={formik.handleBlur}
        placeholder={placeholder}
        className="py-4 px-3 bg-[#E4E6E3] w-full border-none  placeholder:text-[#494949] focus:text-[#494949] focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima"
        disabled={code == "" ? true : false}
      />
      {formik.touched[name] && formik.errors[name] && (
        <div className=" pt-3 text-[12px] text-red-600 font-imprima">
          {formik.errors[name]}
        </div>
      )}
    </>
  );
}
